import React from 'react';
import PropTypes from 'prop-types';
import EventFilter from './EventFilter.jsx';
import debounce from 'lodash.debounce';

export default class EventList extends React.Component {
   constructor(props) {
      super(props);

      this.state = {
         markers: this.props.markers,
         filtered: null,
         active: [],
         expanded: []
      };

      this.handleCountyClick = this.handleCountyClick.bind(this);
      this.handleFilter = this.handleFilter.bind(this);
   }

   handleCountyClick(county) {
      if (this.state.active.indexOf(county) !== -1) {
         this.setState({
            active: this.state.active.filter((c) => c !== county)
         });
      } else {
         this.setState({
            active: [county]
         });
      }
   }

   handleFilter(term) {
      const { activeMarkersGroup, markers } = this.props;

      if (!term) {
         this.setState({
            active: [],
            filtered: null
         });
         return;
      }

      const propertiesToSearch = ['title', 'county']; // Event properties to "search in"
      const filteredCounty = JSON.parse(
         JSON.stringify(markers[activeMarkersGroup].sorted)
      ).filter((county) => {
         const filteredEvents = county.events.filter((ev) => {
            return propertiesToSearch.some((p) => {
               return ev[p] && ev[p].toLowerCase().match(term.toLowerCase());
            });
         });

         if (filteredEvents.length) {
            county.events = filteredEvents;
            return county;
         }
         return false;
      });

      this.setState({
         active: filteredCounty.map((c) => c.county),
         filtered: filteredCounty
      });
   }

   render() {
      const { active, markers, filtered } = this.state;
      const { activeMarkersGroup, eventroot } = this.props;

      const eventLink = (event) => {
         const eventIdIndex = event.lastIndexOf('/');
         const eventId = event.slice(eventIdIndex + 1);
         const eventLink = `?eventid=${eventId}`;

         return eventLink;
      }

      return (
         <div className="eventList">
            <EventFilter
               filter={debounce(this.handleFilter, 100)}
               markers={this.props.markers}
            />
            <div className="eventList_markergroups">
               {markers.map((group, i) => (
                  <button
                     className={
                        i == activeMarkersGroup
                           ? 'eventList_title eventList_title--active'
                           : 'eventList_title'
                     }
                     key={group.header}
                     onClick={this.props.onClick.bind(this, i)}
                  >
                     {group.header}
                  </button>
               ))}
            </div>
            <div className="eventList_counties">
               {filtered && filtered.length === 0 ? (
                  <div className="eventList_county">
                     Ditt søk gir ingen treff
                  </div>
               ) : (
                  ''
               )}
               {(filtered || markers[activeMarkersGroup].sorted).map((e) => (
                  // TODO fix onKeyPress, role and tabIndex, or remove onClick
                  <div
                     className={`eventList_county${
                        active.indexOf(e.county) > -1
                           ? ' eventList_county--active'
                           : ''
                     }`}
                     key={e.county}
                     onClick={this.handleCountyClick.bind(this, e.county)}
                  >
                     <button className="eventList_county_title">
                        {e.county}
                     </button>
                     {e.events.map((ev) => (
                        <a
                           className="eventList_event"
                           key={ev.id}
                           href={`${eventroot}${eventLink(ev.link)}`}
                        >
                           {ev.type === 'event' ? ev.eventLocation : ev.title}
                           {ev.suffix && (
                              <span className="eventList_event_suffix">
                                 {ev.suffix}
                              </span>
                           )}
                        </a>
                     ))}
                  </div>
               ))}
            </div>
         </div>
      );
   }
}

EventList.propTypes = {
   markers: PropTypes.array.isRequired,
   activeMarkersGroup: PropTypes.number,
   eventroot: PropTypes.string,
   onClick: PropTypes.func
};
